<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
		[titleHeaderText]="('guarantee.register' |translate)">
</copo-panel-header>
<div class="guarantee-no-types-label copo-card-container" *ngIf="noOfSelectables() === 0 else typeselector" translate>guarantee.notypes.available</div>
<ng-template #typeselector>
	<div class="copo-card-container">
		<span class="text-margin-container" translate>guarantee.choose.applicationtype</span>
		<div class="pill-guarantee-application">
			<button type="button" mat-button class="guarantee-applicationtype-card" *ngIf="hasSolarAccess()" (click)="solarApplication()">
				<mat-icon svgIcon="solar_icon"></mat-icon>
				<div translate>guarantee.magnelissolar.long</div>
			</button>
			<button type="button" mat-button class="guarantee-applicationtype-card" *ngIf="hasBuildingAccess()" (click)="buildingApplication()">
				<mat-icon svgIcon="building_icon"></mat-icon>
				<div translate>guarantee.magnelisbuilding.long</div>
			</button>
			<button type="button" mat-button class="guarantee-applicationtype-card" *ngIf="hasOthersAccess()" (click)="otherApplication()">
				<mat-icon svgIcon="perfored_sheet_icon"></mat-icon>
				<div translate>guarantee.magnelisothers.long</div>
			</button>
			<button type="button" mat-button class="guarantee-applicationtype-card" *ngIf="hasOrganicCoatingAccess()" (click)="organicCoatingApplication()">
				<mat-icon svgIcon="icon_organic_coating"></mat-icon>
				<div translate>guarantee.organiccoating.long</div>
			</button>
		</div>
	</div>
</ng-template>